import React from 'react';
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { CurrencyFormatter } from '../CurrencyFormatter';
import { commonTransferStyles } from './Common.style';
import { transferSummaryStyles } from './PaymentSummary.style';
import { Typography } from '../Typography';
export const PaymentSummary = ({ lines }) => {
    const commonTransferClasses = commonTransferStyles();
    const transferSummaryClasses = transferSummaryStyles();
    // There was some duplication on the code so i simplified it
    const commonTextNormal = Object.assign(Object.assign({}, commonTransferClasses.commonText), { padding: '0 0 8px' });
    const commonTextBold = Object.assign({}, commonTransferClasses.commonText);
    const SummaryLine = ({ label, amount, isBold }) => {
        return (React.createElement(Box, { sx: transferSummaryClasses.dialogTitle },
            React.createElement(Typography, { variant: isBold ? 'h4-semibold' : 'body-default-regular', sx: isBold ? commonTextBold : commonTextNormal }, label),
            React.createElement(Typography, { variant: isBold ? 'h4-semibold' : 'body-default-regular', sx: isBold ? commonTextBold : commonTextNormal },
                React.createElement(CurrencyFormatter, { amount: amount, withCurrencySymbol: true, minimumFractionDigits: 2 }))));
    };
    return (React.createElement(Box, { sx: commonTransferClasses.commonContentContainer },
        React.createElement(Stack, { sx: transferSummaryClasses.stackStyle }, lines.map((item, index) => (React.createElement(Box, { key: `item-${index}` },
            React.createElement(SummaryLine, Object.assign({}, item))))))));
};
